import { EventEmitter } from '@angular/core';
import { Component, OnInit, Output } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DiscussionService } from 'src/app/shared-service/services/discussion.service';
import { IntersectionStatus } from '../../directives/from-intersection-observer';

import TimeAgo from 'javascript-time-ago'
import en from 'javascript-time-ago/locale/en'
import { ActivatedRoute, Router } from '@angular/router';
import { CreateStoryModalComponent } from '../create-story-modal/create-story-modal.component';
import { take } from 'rxjs/operators';
import { AppConfig } from 'src/app/app.config';
//TimeAgo.addDefaultLocale(en)

@Component({
  selector: 'app-stories-panel',
  templateUrl: './stories-panel.component.html',
  styleUrls: ['./stories-panel.component.css']
})
export class StoriesPanelComponent implements OnInit {

  isLoggedin:boolean = false;

  hideYourStoriesPanel = false;

  selectedStoryObj:any;
  selectedStoryId = '';
  stories=[];
  activeIndex=0;
  myActiveIndex=0;

  selectedMyStoryObj:any;
  selectedMyStoryId = '';
  myStories=[];

  throttle = 1000;
  scrollDistance = 3;
  scrollUpDistance = 1;
  scrollDisable = false;
  myScrollDisable=false;
  pageIndex=0;
  pageMyStoryIndex=0;
  //visibilityStatus: {[key: number]: IntersectionStatus} = {};
  intersectionStatus = IntersectionStatus;
  storyIdArray =[];
  storyMyIdArray=[];
  loading = true;
  myLoading=true;
  fetchViewedStories=0;
  colorPallete = ['green','pink','orange','red','blue', 'gold', 'yelow','violet','silver'];

  slideConfig = {
    "slidesToShow": 1,
    "slidesToScroll": 1,
    "variableWidth": true,
    "infinite": false,
    "autoplay": false,
    "responsive": [{
          "breakpoint": 1200,
          "settings": {"slidesToShow": 1 }
        },
        {
          "breakpoint": 992,
          "settings": {"slidesToShow": 1 }
        },
        {
          "breakpoint": 768,
          "settings": {"slidesToShow": 1}
        },
        {
          "breakpoint": 576,
          "settings": {"slidesToShow": 1}
        }]
  };
  userData:any;
  userId='';
  storyAllObj = {
    0: 0,
    1: 0
  };
  showMyStoryLoader=false;
  showAllStoryLoader=false;
  isMyStoryView = false;

  profileUrl='';
  customProfileName='';
  colorPick='';
  loader=true;
  myloader=true;


  @Output()
  onHide = new EventEmitter();

  constructor(public bsModalRef: BsModalRef,
    private discussionService: DiscussionService,
    private route: ActivatedRoute, private router: Router,
    private config: AppConfig,
    private modalService: BsModalService,) { }

    ngOnInit() {
      if(localStorage.getItem('userData')){
        this.isLoggedin = true;
        this.userData = JSON.parse(localStorage.getItem('userData'));
        this.userId = this.userData.user_id;
      }
      //this.selectedStoryId = this.route.params['value']['storyId'];
      // this.getMyStories();
      // this.getStories();
      // if(document.getElementsByClassName('app-title') && document.getElementsByClassName('app-title')[0]) {
      //   document.getElementsByClassName('app-title')[0]['innerText'] = '';
      // }
      // if(this.discussionService.selectedStoryObj && Object.keys(this.discussionService.selectedStoryObj).length > 0) {
      //   this.selectedStoryObj = this.discussionService.selectedStoryObj;
      //   const timeAgo = new TimeAgo('en-US');
      //   var timeDiff = Date.now().valueOf() - new Date(this.selectedStoryObj.date).valueOf();
      //   this.selectedStoryObj.date = timeAgo.format(Date.now() - timeDiff, 'round');
      //   if(this.selectedStoryObj.user_image && this.selectedStoryObj.user_image.indexOf('dummy-profile') == -1) {
      //     this.selectedStoryObj.selectedStoryObjtem.user_image = this.selectedStoryObj.user_image;
      //   } else if(this.selectedStoryObj.name) {
      //     this.selectedStoryObj.customProfileName = this.selectedStoryObj.name.charAt(0).toUpperCase()
      //   } else {
      //     this.selectedStoryObj.customProfileName = 'G';
      //   }
      //   this.selectedStoryObj.colorPick = this.colorPallete[Math.floor(Math.random() * 9)]
      //   this.stories.push(this.discussionService.selectedStoryObj);
      //   this.storyIdArray.push(this.discussionService.selectedStoryObj['story_id']);
      //   if(this.stories && this.stories.length >0) {
      //     this.selectedStoryId = this.stories[0]['story_id'];
      //   }
      // }

    }

    onMyStoryPanelVisibilityChanged(index: number, status: IntersectionStatus) {
      // this.visibilityStatus[index] = status;
       if(status == 'Visible') {
         this.getMyStories();
       }
     }

    onPanelVisibilityChanged(index: number, status: IntersectionStatus) {
      // this.visibilityStatus[index] = status;
       if(status == 'Visible') {
         this.getStories();
       }
     }

     openStoryPopup(){
      var me =this;
      let ngbModalOptions: NgbModalOptions = {
        backdrop : 'static',
        keyboard : false
    };
      this.modalService.show(CreateStoryModalComponent, ngbModalOptions).content.onHide
      .pipe(take(1))
      .subscribe((result: any) => {
        let fullName = 'Guest user';
        let useridData = '';
        let userpic = '';
        if(this.userData) {
          fullName = this.userData.first_name + ' ' + this.userData.last_name;
          useridData = this.userData.user_id;
          userpic = this.userData.profile_pic;
        }
        let story ={
          date: new Date(),
          image: (result.data && result.data.story_image) ? result.data.story_image : '',
          name: fullName,
          story_color: (result.data && result.data.story_color) ? result.data.story_color : 'black',
          story_desc: (result.data && result.data.story_desc) ? result.data.story_desc : '',
          story_id: (result.data && result.data.story_id) ? result.data.story_id : null,
          totalView: 0,
          user_id: useridData,
          user_image:userpic ,
          user_view: 0,
        }
        me.processMyStoryAtIndex([story], 0);
       // me.myStories.splice(0, 0, story);
      });
    }

     getStories() {
      this.showAllStoryLoader = false;
      this.discussionService.getStories(this.userId, this.storyAllObj[this.fetchViewedStories], this.fetchViewedStories).subscribe(
        (res:any) => {
          if(res && res.data) {
            this.loader=false;
        this.myloader=false;
           // this.stories = [...this.stories,...res.data];
            this.processStoryClick(res.data);
            if(!this.selectedStoryObj) {
              this.selectedStoryId = this.stories[0]['story_id'];
              this.selectedStoryObj =  this.stories[0];
            }
            if(!this.selectedStoryObj.image) {
              this.selectedStoryObj.image='assets/images/'+ this.config.getConfig('LOGO');
            }
            this.storyAllObj[this.fetchViewedStories] = this.storyAllObj[this.fetchViewedStories]+1;
           setTimeout(() => {
            this.showAllStoryLoader = true;
           },100);
           // this.pageIndex++;
          } else {
            if(this.fetchViewedStories == 1) {
              this.loader=false;
        this.myloader=false;
              this.scrollDisable = true;
              this.showAllStoryLoader = false;
            } else {
              this.loader=false;
        this.myloader=false;
              this.fetchViewedStories = 1;
              this.getStories();
            }
          }
        }
      );
    }

    getMyStories() {
      this.discussionService.getMyStories(this.userId, this.pageMyStoryIndex).subscribe(
        (res:any) => {
          if(res && res.data) {
           // this.stories = [...this.stories,...res.data];
           this.showMyStoryLoader = true;
            this.processMyStoryClick(res.data);
            // if(!this.selectedMyStoryObj) {
            //   this.selectedMyStoryId = this.stories[0]['story_id'];
            //   this.selectedMyStoryObj =  this.stories[0];
            // }
            this.pageMyStoryIndex++;
          } else {
            this.myScrollDisable = true;
          }
        }
      );
    }

    processStoryClick(newData) {
      var me =this;
      const timeAgo = new TimeAgo('en-US');
      newData.forEach(item => {
        if(me.storyIdArray.indexOf(item.story_id) == -1) {
          var timeDiff = Date.now().valueOf() - new Date(item.date).valueOf();
          item.date = timeAgo.format(Date.now() - timeDiff, 'round');
          if(item.user_image && item.user_image.indexOf('dummy-profile') == -1) {
            item.user_image = item.user_image;
          } else if(item.name) {
            item.customProfileName = item.name.charAt(0).toUpperCase()
          } else {
            item.customProfileName = 'G';
          }
          item.colorPick = me.colorPallete[Math.floor(Math.random() * 9)];
          if(me.fetchViewedStories == 1) {
            item.isViewedStory = true;
          }
          me.storyIdArray.push(item.story_id);
          me.stories.push(item);
        }
      });
    }

    processMyStoryClick(newData) {
      var me =this;
      const timeAgo = new TimeAgo('en-US');
      newData.forEach(item => {
        if(me.storyMyIdArray.indexOf(item.story_id) == -1) {
          var timeDiff = Date.now().valueOf() - new Date(item.date).valueOf();
          item.date = timeAgo.format(Date.now() - timeDiff, 'round');
          if(item.user_image && item.user_image.indexOf('dummy-profile') == -1) {
            item.user_image = item.user_image;
          } else if(item.name) {
            item.customProfileName = item.name.charAt(0).toUpperCase()
          } else {
            item.customProfileName = 'G';
          }
          item.colorPick = me.colorPallete[Math.floor(Math.random() * 9)]
          me.storyMyIdArray.push(item.story_id);
          me.myStories.push(item);
        }
      });
    }

    processMyStoryAtIndex(newData, index) {
      var me =this;
      const timeAgo = new TimeAgo('en-US');
      newData.forEach(item => {
        if(me.storyMyIdArray.indexOf(item.story_id) == -1) {
          var timeDiff = Date.now().valueOf() - new Date(item.date).valueOf();
          item.date = timeAgo.format(Date.now() - timeDiff, 'round');
          if(item.user_image && item.user_image.indexOf('dummy-profile') == -1) {
            item.user_image = item.user_image;
          } else if(item.name) {
            item.customProfileName = item.name.charAt(0).toUpperCase()
          } else {
            item.customProfileName = 'G';
          }
          item.colorPick = me.colorPallete[Math.floor(Math.random() * 9)]
          me.storyMyIdArray.push(item.story_id);
        //  me.myStories.push(item);
          me.myStories.splice(0, index, item);
        }
      });
    }

    storyClick(story, ind) {
      this.isMyStoryView = false;
      this.loading = true;
      this.selectedStoryId = story.id;
      this.selectedStoryObj = story;
      if(!this.selectedStoryObj.image) {
        this.selectedStoryObj.image='assets/images/'+ this.config.getConfig('LOGO');
      }
      this.activeIndex= ind;
      this.closeModal('');
    }

    myStoryClick(story, ind) {
      this.isMyStoryView = true;
      this.myLoading = true;
      this.selectedStoryId = story.id;
      this.selectedStoryObj = story;
      if(!this.selectedStoryObj.image) {
        this.selectedStoryObj.image='assets/images/'+ this.config.getConfig('LOGO');
      }
      this.myActiveIndex= ind;
      this.closeModal('');
    }

    viewedStory() {
      this.loading = false;
      if(!this.selectedStoryObj.isViewedStory) {
        const formData = new FormData();
        formData.append('user_id', this.userId);
        formData.append('story_id', this.selectedStoryId);
        // api to save story as viewed
        this.discussionService.viewedStory(formData).subscribe((res:any) => {
          if(res && res.data) {
            console.log('story viewed');
            this.stories[this.activeIndex]['isViewedStory']=true;
          }
        })
      }
    }

    viewedMyStory() {
      this.myLoading = false;
    }

    beforeChange(event) {
      console.log(event);
    }

    previousStory() {
      if(this.activeIndex > 0) {
        this.loading = true;
        this.selectedStoryId = this.stories[this.activeIndex-1]['story_id'];
        this.selectedStoryObj =  this.stories[this.activeIndex-1];
        if(!this.selectedStoryObj.image) {
          this.selectedStoryObj.image='assets/images/'+ this.config.getConfig('LOGO');
        }
        this.activeIndex= this.activeIndex-1;
      }
    }
    nextStory() {
      if(this.activeIndex < this.stories.length) {
        this.loading = true;
        this.selectedStoryId = this.stories[this.activeIndex+1]['story_id'];
        this.selectedStoryObj =  this.stories[this.activeIndex+1];
        if(!this.selectedStoryObj.image) {
          this.selectedStoryObj.image='assets/images/'+ this.config.getConfig('LOGO');
        }
        this.activeIndex= this.activeIndex+1;
      }
      if(this.activeIndex == this.stories.length-1) {
        this.loading = true;
        this.getStories();
      }
    }

    myPreviousStory() {
      if(this.myActiveIndex > 0) {
        this.myLoading = true;
        this.selectedStoryId = this.myStories[this.myActiveIndex-1]['story_id'];
        this.selectedStoryObj =  this.myStories[this.myActiveIndex-1];
        if(!this.selectedStoryObj.image) {
          this.selectedStoryObj.image='assets/images/'+ this.config.getConfig('LOGO');
        }
        this.myActiveIndex= this.myActiveIndex-1;
      }
    }
    myNextStory() {
      if(this.myActiveIndex < this.myStories.length) {
        this.myLoading = true;
        this.selectedStoryId = this.myStories[this.myActiveIndex+1]['story_id'];
        this.selectedStoryObj =  this.myStories[this.myActiveIndex+1];
        if(!this.selectedStoryObj.image) {
          this.selectedStoryObj.image='assets/images/'+ this.config.getConfig('LOGO');
        }
        this.myActiveIndex= this.myActiveIndex+1;
      }
      if(this.myActiveIndex == this.myStories.length-1) {
        this.myLoading = true;
        this.getMyStories();
      }
    }

    ngOnDestroy() {
      this.discussionService.selectedStoryObj ={};
    }

  closeModal(result){
    var me =this;
    const finalData = {
      class: 'modal-lg',
       stories:me.stories,
         selectedStoryObj:me.selectedStoryObj,
         selectedStoryId :me.selectedStoryId,
         activeIndex:me.activeIndex,
         myActiveIndex:me.myActiveIndex,
         selectedMyStoryObj:me.selectedMyStoryObj,
         selectedMyStoryId:me.selectedMyStoryId,
         myStories:me.myStories,
         pageIndex:me.pageIndex,
         pageMyStoryIndex:me.pageMyStoryIndex,
         storyIdArray:me.storyIdArray,
         storyMyIdArray:me.storyMyIdArray,
         loading :me.loading,
         myLoading:me.myLoading,
         fetchViewedStories:me.fetchViewedStories,
         storyAllObj :me.storyAllObj,
         showMyStoryLoader:me.showMyStoryLoader,
         showAllStoryLoader:me.showAllStoryLoader,
         isMyStoryView :me.isMyStoryView,
    }

    if(this.selectedMyStoryObj) {
      finalData['storyId']=this.selectedStoryObj.story_id;
    }
    this.onHide.next({data:finalData});
    this.bsModalRef.hide();
  }


}
